import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import type { Widget } from '../shared/types';
import type { GetWidgetRequestParams } from './types';

export const getWidget = async <T = Widget>(
	id: GetWidgetRequestParams['id'],
	lang: GetWidgetRequestParams['lang'] = null,
	options: Pick<GetWidgetRequestParams, 'isApp' | 'widgetsBaseUrl'> = {}
): Promise<AxiosResponse<T>> => {
	const { isApp, widgetsBaseUrl } = options;
	const url = widgetsBaseUrl
		? `${widgetsBaseUrl}/${id}`
		: `/cityzens/widgets/${id}`;

	const params: Record<string, string | boolean> = {};
	if (lang) {
		params.lang = lang;
	}
	if (isApp) {
		params.isApp = true;
	}

	return api.get<T>(url, { params });
};
